import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { MessageBar, MessageBarType } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getErrorMessageBarStyles } from '../../styles/shared-components/error-message-bar';

export const ErrorMessageBarImp = ({
  errorMessage, customClassName, classes, extraAction,
}) => (
  errorMessage ?
    <MessageBar messageBarType={MessageBarType.error} isMultiline className={classNames(classes.errorMessageBar, customClassName)}>
      {errorMessage}
      {extraAction || null}
    </MessageBar> : null
);

ErrorMessageBarImp.propTypes = {
  classes: PropTypes.shape({
    errorMessageBar: PropTypes.string,
  }).isRequired,
  errorMessage: PropTypes.string,
  customClassName: PropTypes.string,
  extraAction: PropTypes.node,
};

ErrorMessageBarImp.defaultProps = {
  errorMessage: '',
  customClassName: '',
  extraAction: null,
};

export const ErrorMessageBar = withDefaultStyles(ErrorMessageBarImp, getErrorMessageBarStyles);
